<template>
    <div class="n-item">
        <div
            v-for="node in list"
            :key="node.remote_id"
            class="nested--item"
        >
            <template v-if="selectedItems ? selectedItems.includes(node.remote_id) : true">
                <div class="nested--item--content">
                    <slot name="item" :node="node" :level="level" class="nested--item--content"></slot>
                </div>

                <nested-list
                    v-if="expandedItems.includes(node.remote_id)"
                    :level="level+1"
                    :list="node.children"
                    :parent="node.remote_id"
                    :expanded-items="expandedItems"
                    :disabled="disabled"
                >
                    <template #item="{node, level}">
                        <slot name="item" :node="node" :level="level"></slot>
                    </template>
                </nested-list>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: "NestedList",
    props: {
        selectedItems: {
            type: [Array, null],
        },
        list: {
            required: true,
            type: [Array],
            default: []
        },
        parent: {
            type: Number,
            default: null
        },
        level: {
            type: Number,
            default: 0
        },
        expandedItems: {
            type: Array,
            default: () => []
        },
        disabled: {
            type: Boolean
        }
    },
    methods: {
        //
    },
}
</script>

<style scoped>
.n-item {
    width: 100%;
    min-width: 100%;
}
@media (max-width: 800px) {
    .n-item {
        min-width: auto;
    }
}
</style>
